import { InjectionToken, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { OutletAction, OutletActionResult, PowerDevice, PowerHistorySample, PowerUpdate } from './power';

/**
 * Injection token for IPowerService.
 */
export const POWER_SERVICE = new InjectionToken<IPowerService>('POWER_SERVICE');

/**
 * Power distribution (PDU) access. Device mode talks to the processor's DashboardHub;
 * cloud mode goes through DeviceRegistry.Api and the device tunnel. Same seam as PING_SERVICE.
 */
export interface IPowerService {
    /** Longest history window (hours) this implementation can serve. */
    readonly maxHistoryHours: number;

    /** False when control is unavailable (e.g. the cloud tunnel is disconnected). */
    readonly canControl: Signal<boolean>;

    /** Live outlet / reading changes. */
    readonly updates$: Observable<PowerUpdate>;

    getDevices(): Promise<PowerDevice[]>;

    executeOutletAction(device: PowerDevice, outletId: number, action: OutletAction): Promise<OutletActionResult>;

    /** Statistics samples, oldest first, for the last `hours` hours. */
    getHistory(device: PowerDevice, hours: number): Promise<PowerHistorySample[]>;
}
